import styled from "styled-components";
import { STYLE_CONSTS } from "~/src/styles/config.style";

export const Text = styled.p`
  text-align: center;
  margin: ${STYLE_CONSTS.UNIT_2};
`;
